/* eslint-disable */
export var tiggerMatrixEditor = false;

export default function init(Blockly, profile, img_path, FieldGridDropdown) {
    Blockly.Blocks.ledmatrix = {};
    Blockly.Blocks.ledmatrix.style = 'ledmatrix_blocks';
    Blockly.Blocks.ledmatrix_ids = [
        ["1", "1"],
        ["2", "2"],
        ["3", "3"],
        ["4", "4"],
        ["5", "5"],
        ["6", "6"],
        ["7", "7"],
        ["8", "8"]
    ];
    Blockly.Blocks.ledmatrix_init = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput().appendField(Blockly.Msg.LEDMATRIX);
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38))
                .appendField(Blockly.Msg.LEDMATRIX_ID)
                .appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids), "ID")
                .appendField(Blockly.Msg.LEDMATRIX_I2C_BEGIN)
                .appendField(Blockly.Msg.LEDMATRIX_I2C_ADDRESS)
                .appendField(new Blockly.FieldDropdown([
                ["0x70", "0x70"],
                ["0x71", "0x71"],
                ["0x72", "0x72"],
                ["0x73", "0x73"],
                ["0x74", "0x74"],
                ["0x75", "0x75"],
                ["0x76", "0x76"],
                ["0x77", "0x77"]]), "ADDR");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.ledmatrix_clear = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput().appendField(Blockly.Msg.LEDMATRIX);
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38)).appendField(Blockly.Msg.LEDMATRIX_ID).appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids), "ID").appendField(Blockly.Msg.LEDMATRIX_CLEAR);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.ledmatrix_drawpixel = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput().appendField(Blockly.Msg.LEDMATRIX);
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38))
                .appendField(Blockly.Msg.LEDMATRIX_ID)
                .appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids), "ID")
                .appendField(Blockly.Msg.LEDMATRIX_DRAWPIXEL);
            this.appendValueInput("X", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("X");
            this.appendValueInput("Y", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("Y");
            this.appendDummyInput("").appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.LEDMATRIX_LED_ON, "LED_ON"],
                [Blockly.Msg.LEDMATRIX_LED_OFF, "LED_OFF"]
            ]), "COL");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.ledmatrix_drawline = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput().appendField(Blockly.Msg.LEDMATRIX);
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38))
                .appendField(Blockly.Msg.LEDMATRIX_ID)
                .appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids), "ID")
                .appendField(Blockly.Msg.LEDMATRIX_LINE);
            this.appendValueInput("X1", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("X1");
            this.appendValueInput("Y1", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("Y1");
            this.appendValueInput("X2", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("X2");
            this.appendValueInput("Y2", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("Y2");
            this.appendDummyInput("").appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.LEDMATRIX_LED_ON, "LED_ON"],
                [Blockly.Msg.LEDMATRIX_LED_OFF, "LED_OFF"]
            ]), "COL");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.ledmatrix_drawrectangle = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput().appendField(Blockly.Msg.LEDMATRIX);
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38)).appendField(Blockly.Msg.LEDMATRIX_ID).appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids),
                "ID").appendField(Blockly.Msg.LEDMATRIX_RECTANGLE);
            this.appendValueInput("X1", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("X");
            this.appendValueInput("Y1", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("Y");
            this.appendValueInput("X2", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.LEDMATRIX_WIDTH);
            this.appendValueInput("Y2", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.LEDMATRIX_HEIGHT);
            this.appendDummyInput("").appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.LEDMATRIX_LED_ON, "LED_ON"],
                [Blockly.Msg.LEDMATRIX_LED_OFF, "LED_OFF"]
            ]), "COL");
            this.appendDummyInput("").appendField(" ").appendField(new Blockly.FieldCheckbox("FALSE"), "FILL").appendField(Blockly.Msg.LEDMATRIX_FILL);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.ledmatrix_drawcircle = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput().appendField(Blockly.Msg.LEDMATRIX);
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38)).appendField(Blockly.Msg.LEDMATRIX_ID).appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids),
                "ID").appendField(Blockly.Msg.LEDMATRIX_DRAWCIRCLE);
            this.appendValueInput("X", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("X");
            this.appendValueInput("Y", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("Y");
            this.appendValueInput("R", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("R");
            this.appendDummyInput("").appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.LEDMATRIX_LED_ON, "LED_ON"],
                [Blockly.Msg.LEDMATRIX_LED_OFF, "LED_OFF"]
            ]), "COL");
            this.appendDummyInput("").appendField(" ").appendField(new Blockly.FieldCheckbox("FALSE"),
                "FILL").appendField(Blockly.Msg.LEDMATRIX_FILL);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.ledmatrix_drawtext = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput().appendField(Blockly.Msg.LEDMATRIX);
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38)).appendField(Blockly.Msg.LEDMATRIX_ID).appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids),
                "ID").appendField(Blockly.Msg.LEDMATRIX_DRAWTEXT);
            this.appendValueInput("X", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("X");
            this.appendValueInput("Y", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField("Y");
            this.appendValueInput("TXT", "String");
            this.appendDummyInput("").appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.LEDMATRIX_LED_ON, "LED_ON"],
                [Blockly.Msg.LEDMATRIX_LED_OFF, "LED_OFF"]
            ]), "COL");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.ledmatrix_callbackEditor = function() {
        return function() {
            tiggerMatrixEditor = true;
        };
    };
    Blockly.Blocks.ledmatrix_drawbitmap = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput().appendField(Blockly.Msg.LEDMATRIX);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38))
                .appendField(Blockly.Msg.LEDMATRIX_ID)
                .appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids), "ID")
                .appendField(Blockly.Msg.LEDMATRIX_DRAWBITMAP)
                .appendField(new Blockly.FieldTextInput(""), "DATA");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        },
        customContextMenu: function(options) {
            if (this.isInFlyout) return;
            tiggerMatrixEditor = false;
            if (!this.isCollapsed()) {
                var option;
                option = {
                    text:     Blockly.Msg.LEDMATRIX_EDITOR,
                    callback: Blockly.Blocks.ledmatrix_callbackEditor(),
                    enabled:  true
                };
            options.push(option);
            }
          },
    };
    Blockly.Blocks.ledmatrix_drawsprite = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput().appendField(Blockly.Msg.LEDMATRIX);
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38)).appendField(Blockly.Msg.LEDMATRIX_ID).appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids),
                "ID").appendField(Blockly.Msg.LEDMATRIX_DRAWBITMAP).appendField(new FieldGridDropdown([
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_happy.svg', 'width': 60, 'height': 60, 'alt': 'Happy'}, "face_happy"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_sad.svg', 'width': 60, 'height': 60, 'alt': 'Sad'}, "face_sad"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_angry.svg', 'width': 60, 'height': 60, 'alt': 'Angry'}, "face_angry"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_heart.svg', 'width': 60, 'height': 60, 'alt': 'Heart'}, "icon_heart"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_up.svg', 'width': 60, 'height': 60, 'alt': 'Up'}, "icon_arrowU"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_down.svg', 'width': 60, 'height': 60, 'alt': 'Up'}, "icon_arrowD"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_left.svg', 'width': 60, 'height': 60, 'alt': 'Left'}, "icon_arrowL"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_right.svg', 'width': 60, 'height': 60, 'alt': 'Right'}, "icon_arrowR"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_rain.svg', 'width': 60, 'height': 60, 'alt': 'Rain'}, "icon_ray"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_moon.svg', 'width': 60, 'height': 60, 'alt': 'Moon'}, "icon_moon"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_cloud.svg', 'width': 60, 'height': 60, 'alt': 'Cloud'}, "icon_cloud"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_forbidden.svg', 'width': 60, 'height': 60, 'alt': 'Forbidden'}, "icon_forbidden"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_infinite.svg', 'width': 60, 'height': 60, 'alt': 'Infinite'}, "icon_infinite"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_look left.svg', 'width': 60, 'height': 60, 'alt': 'Look Left'}, "icon_look_left"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_look right.svg', 'width': 60, 'height': 60, 'alt': 'Look right'}, "icon_look_right"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_note.svg', 'width': 60, 'height': 60, 'alt': 'note'}, "icon_note"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_ok.svg', 'width': 60, 'height': 60, 'alt': 'OK'}, "icon_ok"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_ouch.svg', 'width': 60, 'height': 60, 'alt': 'Ouch'}, "icon_ouch"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_plus.svg', 'width': 60, 'height': 60, 'alt': 'Plus'}, "icon_plus"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_question.svg', 'width': 60, 'height': 60, 'alt': 'Question'}, "icon_question"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_serious.svg', 'width': 60, 'height': 60, 'alt': 'Serious'}, "icon_serious"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_smile.svg', 'width': 60, 'height': 60, 'alt': 'Smile'}, "icon_smile"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_sun.svg', 'width': 60, 'height': 60, 'alt': 'Sun'}, "icon_sun"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_surprised.svg', 'width': 60, 'height': 60, 'alt': 'Surprised'}, "icon_surpirsed"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_tic.svg', 'width': 60, 'height': 60, 'alt': 'Tic'}, "icon_tic"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_unhappy.svg', 'width': 60, 'height': 60, 'alt': 'Unhappy'}, "icon_unhappy"],
                [{'src': img_path + 'icons/matrix/Iconos_ledmatrix_yummy.svg', 'width': 60, 'height': 60, 'alt': 'Yummy'}, "icon_yummy"],
            ]), "SPRITE");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.ledmatrix_rotation = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput().appendField(Blockly.Msg.LEDMATRIX);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38))
                .appendField(Blockly.Msg.LEDMATRIX_ID)
                .appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids),
                "ID").appendField(Blockly.Msg.LEDMATRIX_ROTATION).appendField(new Blockly.FieldDropdown([
                ["0\u00ba", "0"],
                ["90\u00ba", "1"],
                ["180\u00ba", "2"],
                ["-90\u00ba", "3"]
            ]), "ROT");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.ledmatrix_show = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38)).appendField(Blockly.Msg.LEDMATRIX_ID).appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids), "ID").appendField(Blockly.Msg.LEDMATRIX_SHOW);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.ledmatrix_drawmatrix = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput().appendField(Blockly.Msg.LEDMATRIX);
            this.setStyle(Blockly.Blocks.ledmatrix.style);
            this.appendDummyInput("")
            .appendField(new Blockly.FieldImage(img_path + "arduino/ledmatrix.svg", 50, 38))
                                    .appendField(Blockly.Msg.LEDMATRIX_ID)
                                    .appendField(new Blockly.FieldDropdown(Blockly.Blocks.ledmatrix_ids),"ID")
                                    .appendField(Blockly.Msg.LEDMATRIX_DRAWBITMAP);
            for (var a = 0; 8 > a; a++) {
                for (var b = this.appendDummyInput(""), c = 0; 8 > c; c++) {
                    b.appendField(new Blockly.FieldCheckboxRound("FALSE"), "R" + a.toString() + "C" + c.toString());
                }
            }
            this.setInputsInline(false);
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
        }
    };
}
